// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__OsIYK","left":"InfoRow_left__2BnpL"};